"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var floor_1 = require("../utility/floor");
var colors_1 = require("../components/sharedStyle/colors");
var luxon_1 = require("luxon");
var createDatasets = function (item, index, format, columnType, barType, labels, isAll) {
    var data = labels && item.rows
        ? labels.map(function (label) {
            var _a, _b;
            return (_b = (_a = item.rows) === null || _a === void 0 ? void 0 : _a.find(function (row) {
                return row.columns && columnType === 'TIME_RANGE'
                    ? luxon_1.Duration.fromObject({ seconds: parseInt(row.columns[0], 10) }).toFormat(format) === label
                    : row.columns
                        ? row.columns[0] === label
                        : false;
            })) === null || _b === void 0 ? void 0 : _b.value;
        })
        : undefined;
    var label = item.label;
    return {
        type: item.type.toLowerCase() !== 'line' && barType ? (barType === 'LINE' ? 'line' : 'bar') : item.type.toLowerCase(),
        label: label,
        borderColor: isAll && item.color ? item.color : colors_1["default"][index % 8],
        backgroundColor: isAll && item.color ? item.color : colors_1["default"][index % 8],
        pointBackgroundColor: isAll && item.color ? item.color : colors_1["default"][index % 8],
        pointBorderColor: isAll && item.color ? item.color : colors_1["default"][index % 8],
        pointHoverBackgroundColor: isAll && item.color ? item.color : colors_1["default"][index % 8],
        pointHoverBorderColor: isAll && item.color ? item.color : colors_1["default"][index % 8],
        data: item.percentage ? data === null || data === void 0 ? void 0 : data.map(function (value) { return (value ? (0, floor_1["default"])(+value, 4) : null); }) : data,
        fill: false,
        yAxisID: item.position && item.position.toUpperCase() == 'RIGHT' ? 'right-y-axis' : 'left-y-axis',
        pointHoverBorderWidth: item.type == 'LINE' ? 2 : undefined,
        pointHoverRadius: item.type == 'LINE' ? 4 : undefined,
        spanGaps: true
    };
};
var convertChartData = function (chart, datasetsValue, frequency, barType, customColors) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var selectedChart = Array.isArray(chart)
        ? (_a = chart.find(function (item) { var _a, _b; return ((_b = (_a = item.header) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.frequency) === frequency; })) !== null && _a !== void 0 ? _a : chart[0]
        : chart;
    var columns = ((_c = (_b = selectedChart.structure.dimensions) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.columns) || selectedChart.columns || [];
    var isHour = ((_e = (_d = selectedChart.structure.dimensions) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.columnType) === 'TIME_RANGE' || selectedChart.columnType === 'TIME_RANGE'
        ? Math.max.apply(Math, columns.map(function (column) { return parseInt(column); })) >= 3600
        : false;
    var format = isHour ? 'hh:mm:ss' : 'mm:ss';
    // structure.dimensions.columns を優先
    var labels = ((_g = (_f = selectedChart.structure.dimensions) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.columnType) === 'TIME_RANGE' || selectedChart.columnType === 'TIME_RANGE'
        ? columns.map(function (column) { return luxon_1.Duration.fromObject({ seconds: parseInt(column, 10) }).toFormat(format); })
        : columns;
    var datasets = (_j = (_h = selectedChart.structure.datasets) === null || _h === void 0 ? void 0 : _h.slice().sort(function (a, b) {
        if (a.type === 'LINE' && b.type !== 'LINE')
            return -1;
        return 0;
    }).map(function (item, index) {
        var _a, _b;
        var datasetItem = customColors
            ? __assign(__assign({}, item), { color: Array.isArray(customColors) ? customColors[index % customColors.length] : customColors }) : item;
        return {
            datasets: createDatasets(datasetItem, index, format, ((_b = (_a = selectedChart.structure.dimensions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.columnType) || selectedChart.columnType, datasetsValue !== 'all' ? barType : undefined, labels, datasetsValue === 'all'),
            id: item.id
        };
    })) !== null && _j !== void 0 ? _j : [];
    if (datasetsValue === 'all') {
        return {
            labels: labels,
            datasets: datasets.map(function (item) { return item.datasets; })
        };
    }
    return {
        labels: labels,
        datasets: datasets.filter(function (item) { return item.id == datasetsValue; }).map(function (item) { return item.datasets; })
    };
};
exports["default"] = convertChartData;
